import { ActivableModel } from '@app/core/models/shared/activable.model';
import { GroupModel } from '../groups/group.model';

export class RecipientEntityModel extends ActivableModel {

  constructor() {
    super();
  }

  public Id: number;

  public Name: string;

  public OperationalGroupId: number | null;

  public OperationalGroupName: string;

  public ObservationGroupId: number | null;

  public ObservationGroupName: string | null;

  public OperationalGroupSupervisorUserId: string;

  public OperationalGroupSupervisorUserName: string;

  public OperationalGroupProfessionTypeId: number;

  public OperationalGroupProfessionTypeName: string;

  public OperationalGroupIsVoucher: boolean;

  public SupervisionGroups: Array<GroupModel>;
}
